import Tender         from "@/domains/Tenders/Tender";
import TendersService from "@/domains/Tenders/TendersService";
import DateSimple     from "@/core/types/DateSimple";
import Price          from "@/core/types/Price";
import Product        from "@/domains/Products/Product";
import Core           from "@/core/Core";
import type Store     from "@/domains/Stores/Store";

/**
 * Пачка тендеров для множественного создания.
 *
 * От прежней версии остались только обязанности, которые действительно про
 * пачку: агрегированные даты, инициализация стартовых цен по товарам и
 * удаление элемента. Каскадный прокси и masterTender убраны — форма работает
 * с одним тендером-образцом, а раскладка общих полей по пачке происходит
 * перед отправкой через Tender.applySharedFieldsFrom.
 */
export default class TendersAggregator {
  public tenders: Tender[] = [];

  constructor(tenders: Tender[]) {
    this.tenders = tenders;
  }

  /** Образец, по которому равняется вся пачка — первый тендер. */
  get sampleTender(): Tender {
    return this.tenders[0];
  }

  removeTenderByIndex(index: number): void {
    this.tenders.splice(index, 1);
  }

  /**
   * Стартовые цены из прошлых заказов, одним запросом на всю пачку.
   * Цена индивидуальна для каждого тендера — в общие поля не входит.
   * Доставка в цене считается до склада покупателя, поэтому без склада цены не грузятся.
   */
  async initPrices(buyerStore: Store): Promise<void> {
    const data = await TendersService.getPriceForNewTender(
      this.tenders.map(tender => ({ id: tender.product.id } as Product)),
      buyerStore,
      /** берем сегодняшнюю дату, чтобы корректно рассчитать курс */
      DateSimple.today(),
    );

    if (data !== null) {
      const productsWithoutTenders: string[] = [];

      this.tenders.forEach((tender) => {
        const tenderPriceInfo = data[tender.product.id];

        if (Core.utils.isNullOrUndefined(tenderPriceInfo) === true) {
          productsWithoutTenders.push(tender.product.name);
        } else {
          tender.priceStartCurrencyCode = tenderPriceInfo.currencyCode;
          tender.priceStartFull = Price.fromServer(tenderPriceInfo.prices[tenderPriceInfo.currencyCode]);
        }
      });

      if (productsWithoutTenders.length > 0) {
        Core.showNotification.warning(
          `Тендеров с заказом по этим товарам ещё не было — стартовую цену введите вручную: ${productsWithoutTenders.join(', ')}`,
        );
      }
    }
  }
}
